import { Routes } from '@angular/router';

import { AppContentLayoutComponent } from './core/layouts/app-content-layout/app-content-layout.component';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { SettingsLayoutComponent } from './core/layouts/settings-layout/settings-layout.component';
import { resolveTermsAcceptanceTitle } from './core/navigation/route-title.resolvers';
import { authInitGuard } from './core/security/guards/auth-init.guard';
import { authGuard } from './core/security/guards/auth.guard';
import { devLocalBypassGuard } from './core/security/guards/dev-local-bypass.guard';
import { environmentGuard } from './core/security/guards/environment.guard';
import { internalLoginSessionGuard } from './core/security/guards/internal-login-session.guard';
import { pendingTermsGuard } from './core/security/guards/pending-terms.guard';
import { privilegedAccessGuard } from './core/security/guards/privileged-access.guard';
import { stripLocalDevQueryGuard } from './core/security/guards/strip-local-dev-query.guard';
import { stripTokenGuard } from './core/security/guards/strip-token.guard';
import { termsAcceptanceGuard } from './core/security/guards/terms-acceptance.guard';

export const routes: Routes = [
  {
    path: 'internal-login',
    title: 'Login interno',
    canMatch: [devLocalBypassGuard],
    canActivate: [internalLoginSessionGuard],
    loadComponent: () =>
      import('./core/auth/pages/internal-login/internal-login.component').then(
        (c) => c.InternalLoginComponent
      )
  },
  {
    path: 'onboarding',
    title: 'Onboarding',
    canMatch: [environmentGuard],
    loadComponent: () =>
      import('./features/onboarding/onboarding.component').then(
        (c) => c.OnboardingComponent
      )
  },
  {
    path: 'error',
    title: 'Erro',
    loadChildren: () =>
      import('./features/error/error.routes').then((r) => r.ErrorRoutes)
  },
  {
    path: 'aceite-de-termos/:termId',
    title: resolveTermsAcceptanceTitle,
    canActivate: [
      stripTokenGuard,
      authGuard,
      stripLocalDevQueryGuard,
      authInitGuard,
      pendingTermsGuard
    ],
    loadComponent: () =>
      import('./features/general/pages/terms-acceptance/terms-acceptance.component').then(
        (c) => c.TermsAcceptanceComponent
      )
  },
  {
    path: 'termos-indisponiveis',
    title: 'Termos indisponíveis',
    canActivate: [
      stripTokenGuard,
      authGuard,
      stripLocalDevQueryGuard,
      authInitGuard
    ],
    loadComponent: () =>
      import('./features/general/pages/terms-unavailable/terms-unavailable.component').then(
        (c) => c.TermsUnavailableComponent
      )
  },
  {
    path: '',
    canActivate: [
      stripTokenGuard,
      authGuard,
      stripLocalDevQueryGuard,
      authInitGuard
    ],
    canActivateChild: [stripTokenGuard, authGuard, termsAcceptanceGuard],
    children: [
      {
        path: '',
        component: MainLayoutComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'inicio'
          },
          {
            path: '',
            component: AppContentLayoutComponent,
            children: [
              {
                path: 'inicio',
                title: 'Início',
                loadComponent: () =>
                  import('./features/home/home.component').then(
                    (c) => c.HomeComponent
                  )
              },
              {
                path: 'turmas',
                title: 'Turmas',
                data: { breadcrumb: 'Turmas' },
                loadChildren: () =>
                  import('./features/classes/routes').then(
                    (r) => r.ClassesRoutes
                  )
              },
              {
                path: 'livros',
                title: 'Livros',
                data: { syncCycleId: true, fullBleed: true },
                loadComponent: () =>
                  import('./features/book/pages/books/books.component').then(
                    (c) => c.BooksComponent
                  )
              },
              {
                path: 'materiais',
                title: 'Materiais',
                data: {
                  breadcrumb: 'Materiais'
                },
                loadChildren: () =>
                  import('./features/materials/routes').then(
                    (r) => r.MaterialsRoutes
                  )
              },
              {
                path: 'relatorios',
                title: 'Relatórios',
                data: { breadcrumb: 'Relatórios' },
                loadChildren: () =>
                  import('./features/reports/routes').then(
                    (r) => r.ReportRoutes
                  )
              }
            ]
          },
          {
            path: 'configuracoes-gerais',
            title: 'Configurações gerais',
            component: SettingsLayoutComponent,
            loadChildren: () =>
              import('./features/general/routes').then((r) => r.GeneralRoutes)
          },
          {
            path: 'configuracoes',
            title: 'Configurações',
            component: SettingsLayoutComponent,
            canActivate: [privilegedAccessGuard],
            loadChildren: () =>
              import('./features/admin/routes').then((r) => r.AdminRoutes)
          }
        ]
      },
      {
        path: 'livro-digital',
        title: 'Livro digital',
        canMatch: [environmentGuard],
        loadComponent: () =>
          import('./features/book/pages/book-preview/book-preview.component').then(
            (c) => c.BookPreviewComponent
          )
      }
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'error/404'
  }
];
